import { useTranslation } from 'react-i18next';

import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';
import { ProjectEditionFormWrapper } from 'src/Components/Forms/Project/ProjectEditionFormWrapper';

const EditProjectDrawer = () => {
  const { t } = useTranslation();

  return (
    <AnimatedRoutedDrawer title={t('projects.edit.title', 'Modifier le projet')}>
      {({ onClose }) => <ProjectEditionFormWrapper onClose={onClose} />}
    </AnimatedRoutedDrawer>
  );
};

export default EditProjectDrawer;
